import { render, staticRenderFns } from "./HostItem.vue?vue&type=template&id=975e00e6&"
import script from "./HostItem.vue?vue&type=script&lang=js&"
export * from "./HostItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports